// extracted by mini-css-extract-plugin
export var noSpinners = "_nx-6";
export var percentageInput = "_nx-7";
export var variantColor1 = "_nx-0";
export var variantColor2 = "_nx-1";
export var variantColor3 = "_nx-2";
export var variantColor4 = "_nx-3";
export var variantColor5 = "_nx-4";
export var variantColor6 = "_nx-5";